<template>
	<div v-if="minPageNumber != 0 && maxPageNumber != 0 && totalCount > 0" class="paging_nav">
		<!-- {{ minPageNumber }} -->
		<a v-if="prevPageNumber != 0" @click="gotoPage(prevPageNumber)" href="javascript:;" class="page_select prev_page">Prev</a>
		<span>
			<template v-for="i in maxPageNumber - minPageNumber + 1">
				<template v-if="i + minPageNumber - 1 == pageNumber">
					<strong v-bind:key="i">{{ i + minPageNumber - 1 }}</strong>
				</template>
				<template v-else>
					<a v-bind:key="i" @click="gotoPage(i + minPageNumber - 1)" href="javascript:;">{{ i + minPageNumber - 1 }}</a>
				</template>
			</template>
		</span>
		<a v-if="nextPageNumber != 0" @click="gotoPage(nextPageNumber)" href="javascript:;" class="page_select next_page">Next</a>
	</div>
</template>

<script>
export default {
	data: function() {
		return {
			pageNumber: null, // 페이지번호
			pageSize: null, // 페이지크기
			totalCount: null, // 전체 행의 갯수
			totalPage: null, // 전체 페이지 수
			pageCount: 10, // 네비게이션에 보여줄 페이지 수
			minPageNumber: null, // 시작 페이지 번호
			maxPageNumber: null, // 끝 페이지 번호
			prevPageNumber: null, // 이전 페이지 번호
			nextPageNumber: null, // 다음 페이지 번호
			firstPageNumber: null, // 첫목록
			lastPageNumber: null, // 끝목록
		};
	},
	methods: {
		gotoPage(pageNo) {
			this.$emit('gotoPage', pageNo);
		},
		setPage(pageNumber, pageSize, totalCount) {
			this.pageNumber = pageNumber; //11
			this.pageSize = pageSize; //20
			this.totalCount = totalCount; //1189
			this.totalPage = Math.ceil(totalCount / pageSize); //60
			//console.log(pageNumber, pageSize, totalCount, this.totalPage);

			var minPageNo;
			if (this.pageNumber % this.pageCount == 0) {
				minPageNo = Math.floor(this.pageNumber / this.pageCount) * this.pageCount - (this.pageCount - 1);
			} else {
				minPageNo = Math.floor(this.pageNumber / this.pageCount) * this.pageCount + 1;
			}

			var pageCnt = Math.ceil(this.totalCount / this.pageSize) - minPageNo;
			//console.log(pageNumber, pageSize, totalCount, this.totalPage, minPageNo, pageCnt);

			if (pageCnt > this.pageCount) {
				pageCnt = this.pageCount - 1;
			}
			var maxPageNo = minPageNo + pageCnt;

			this.minPageNumber = minPageNo;
			this.maxPageNumber = maxPageNo;

			if (this.pageNumber <= this.pageCount) {
				this.prevPageNumber = 0;
				this.firstPageNumber = 0;
			} else {
				this.prevPageNumber = this.minPageNumber - 1;
				this.firstPageNumber = 1;
			}

			if (this.minPageNumber + this.pageCount >= this.totalPage) {
				this.nextPageNumber = 0;
				this.lastPageNumber = 0;
			} else {
				this.nextPageNumber = this.maxPageNumber + 1;
				this.lastPageNumber = this.totalPage;
			}
			//console.log(this.prevPageNumber, this.nextPageNumber);
			//console.log(this.minPageNumber, this.maxPageNumber);
		},
	},
};
</script>

<style></style>
